/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useRef } from 'react'
import { InputComponent, InputProps } from 'LibNeo'
import { FieldNames } from 'Src/constants/FieldNames'
import { onFocusQuotes, trimSpaces } from 'Helpers'
import { Validators } from 'Modules'
import { isLatinFields, translateOptions, trimQuotes } from 'Pages/registratorCabinet'
import { Callback } from 'Types/utilTypes'

interface ComponentProps extends InputProps {
	required: boolean
	initialValue: string
}

export const QuotesInput: FC<ComponentProps> = (props) => {
	const { required, initialValue, form, fieldName, onChange } = props
	const inputRef = useRef<{ input: HTMLInputElement }>(null)

	const isLatin = isLatinFields.includes(fieldName as FieldNames)

	const onFocus = onFocusQuotes({
		form,
		fieldName,
		onChange,
		ref: inputRef,
	})

	const onBlur: Callback = () => {
		let value = form.getFieldValue(fieldName)
		value = trimSpaces(value)
		value = trimQuotes(value)
		form.setFieldsValue({ [fieldName]: value })
		form.validateFields([fieldName])
	}

	useEffect(() => {
		form.validateFields([fieldName], { force: true })
	}, [form.getFieldValue(fieldName)])

	return (
		<>
			<InputComponent
				{...props}
				getInputRef={inputRef}
				fieldName={fieldName}
				type="text"
				fieldOptions={{
					initialValue,
					rules: [
						{
							validator: Validators.checkCyrillicOrLatinQuotes({
								required,
								payload: {
									isLatin,
								},
							}),
						},
					],
				}}
				helpText={`${translateOptions[fieldName]} ${
					form?.getFieldValue(fieldName)
						? `${form?.getFieldValue(fieldName)}
`
						: ''
				}`}
				onFocus={onFocus}
				onBlur={onBlur}
			/>
		</>
	)
}
